import React from 'react';
import { CalendarDays as CalendarDaysIcon, ListChecks as ListChecksIcon, LockKeyhole as LockKeyholeIcon, ShoppingBasket as ShoppingBasketIcon, Soup as SoupIcon, Utensils as UtensilsIcon, Zap as ZapIcon } from 'lucide-react';
const offerItems = [{
  icon: UtensilsIcon,
  name: '21 Days of Radiant Mornings',
  detail: 'The Bread-Free Breakfast Plan for Women in Menopause',
  value: '$37.00',
  included: 'INCLUDED'
}, {
  icon: CalendarDaysIcon,
  name: 'Bonus #1 — 7-Day Starter Meal Plan',
  detail: 'A full week of breakfasts, planned for you',
  value: '$10.00',
  included: 'FREE'
}, {
  icon: ShoppingBasketIcon,
  name: 'Bonus #2 — Smart Grocery List',
  detail: 'Everything to keep stocked, nothing wasted',
  value: '$10.00',
  included: 'FREE'
}, {
  icon: ZapIcon,
  name: 'Bonus #3 — Weekend Prep Guide',
  detail: '30 min on Sunday = stress-free week',
  value: '$10.00',
  included: 'FREE'
}, {
  icon: ListChecksIcon,
  name: 'Bonus #4 — Hormone-Friendly Pantry Checklist',
  detail: 'Support hormonal balance after 50',
  value: '$10.00',
  included: 'FREE'
}, {
  icon: SoupIcon,
  name: 'Bonus #5 — 10 Smoothies to Beat the Energy Crash',
  detail: 'Blood sugar balance in under 3 minutes',
  value: '$10.00',
  included: 'FREE'
}];
export function OfferSection() {
  return <section id="offer" className="bg-cream py-20 sm:py-24" data-id="element-108" data-mp="1lmmhyhw0vjfc">
      <div className="mx-auto max-w-5xl px-5 lg:px-8" data-id="element-109" data-mp="1lk0asjd1n5xn">
        <div className="text-center" data-id="element-110" data-mp="1gol183m2jw71">
          <p className="eyebrow" data-id="element-111" data-mp="1glgp8k2d3w5t">Special offer</p>
          <h2 className="section-title mt-3" data-id="element-112" data-mp="1ckn0xpl0cfce">
            Invest in your mornings once — feel the difference for life
          </h2>
          <p className="mx-auto mt-5 max-w-2xl leading-7 text-forest/70" data-id="element-113" data-mp="17mbsnjad2cwa">
            Less than the cost of a single breakfast out. You get the complete
            system — 50 recipes + 5 bonuses — for a one-time price that will
            make you wonder why it&apos;s this low.
          </p>
        </div>
        <div className="mt-12 overflow-hidden rounded-3xl border border-forest/15 bg-white shadow-xl shadow-forest/5" data-id="element-114" data-mp="3trwqernj0x3n">
          <div className="border-b border-forest/10 bg-forest px-6 py-5 text-cream sm:px-8" data-id="element-115" data-mp="3ktbal49fvw6k">
            <h3 className="font-serif text-2xl" data-id="element-116" data-mp="3ouwmama8m4f6">Everything you get today</h3>
          </div>
          <div className="p-5 sm:p-8" data-id="element-117" data-mp="3owr96652k6lw">
            {offerItems.map(({
            icon: Icon,
            name,
            detail,
            value,
            included
          }) => <div key={name} className="flex gap-3 border-b border-forest/10 py-4 last:border-0" data-id="element-118" data-mp="3fuqcbadqzmkr">
                <Icon size={20} className="mt-1 shrink-0 text-olive" data-id="element-119" data-mp="316wtlgtd83xy" />
                <div className="flex-1" data-id="element-120" data-mp="365gk7uiwm3wn">
                  <h4 className="text-sm font-extrabold text-forest" data-id="element-121" data-mp="362c8mc3405vy">{name}</h4>
                  <p className="mt-1 text-xs text-forest/65" data-id="element-122" data-mp="2s55qmjq7mb7s">{detail}</p>
                </div>
                <div className="shrink-0 text-right" data-id="element-123" data-mp="2x2fh82pc4sx7">
                  <p className="text-sm font-semibold text-forest/60" data-id="element-124" data-mp="2dhowpae3k6cp">
                    {value}
                  </p>
                  <p className="mt-1 text-xs font-extrabold text-terracotta" data-id="element-125" data-mp="28jnhj0jskr6i">
                    {included}
                  </p>
                </div>
              </div>)}
            <div className="mt-5 grid gap-4 rounded-2xl bg-sand p-5 sm:grid-cols-2 sm:items-center" data-id="element-126" data-mp="2igie3dwi8hi5">
              <div data-id="element-127" data-mp="2wg9jiq8ygpkj">
                <p className="text-sm font-bold text-forest/65" data-id="element-128" data-mp="2wfrjrjn33t7v">
                  Total real value
                </p>
                <p className="font-serif text-3xl text-forest line-through decoration-terracotta" data-id="element-129" data-mp="2rh6ozzqlq1qt">
                  $87.00
                </p>
              </div>
              <div className="sm:text-right" data-id="element-130" data-mp="3179gtwlzl9nk">
                <p className="text-sm font-bold text-forest/65" data-id="element-131" data-mp="319ma35x736fx">
                  You pay today{' '}
                  <span className="font-normal" data-id="element-132" data-mp="3f57vz484ta44">
                    · One-time · Lifetime access
                  </span>
                </p>
                <p className="font-serif text-4xl text-terracotta" data-id="element-133" data-mp="18jjuvain23py">$19.97</p>
                <p className="mt-1 text-xs font-extrabold text-olive" data-id="element-134" data-mp="1di4yljx3n5j5">
                  You save $67.03 (77.05% OFF)
                </p>
              </div>
            </div>
            <a id="purchase" href="https://pay.hotmart.com/Q106802782G?checkoutMode=10" className="mt-6 flex w-full items-center justify-center gap-3 rounded-full bg-terracotta px-6 py-5 text-center text-base font-extrabold tracking-wide text-white shadow-lg shadow-terracotta/25 transition hover:bg-[#a84a35] focus:outline-none focus:ring-4 focus:ring-terracotta/30" data-id="element-135" data-mp="1iay4ib4b0jwt">
              YES — CLAIM MY 21 DAYS OF RADIANT MORNINGS NOW →
            </a>
            <p className="mt-4 flex items-center justify-center gap-2 text-center text-xs font-semibold text-forest/60" data-id="element-136" data-mp="13huls0ez804i">
              <LockKeyholeIcon size={13} data-id="element-137" data-mp="2ez460p5xiw6v" /> Secure checkout · Instant delivery
              to your email · 7-day guarantee
            </p>
          </div>
        </div>
      </div>
    </section>;
}